import type { MyLearningTabs } from './MyLearningTabContent';

export const getMyLearningDeepLink = (tab: MyLearningTabs) => {
  return `currentTab=MY_LEARNING&myLearningTab=${tab}`;
};
